<template>
    <!-- Logo -->
    <div class="wordmark_container">
        <router-link to="/">
            <img src="/images/logotype_davidmoreau.svg" alt="David Moreau" class="wordmark">
        </router-link>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { useSpaceScale, useSemanticColors } from '@/composables/useStyleVariables';
import { usePortfolioStore } from '@/stores/portfolio';

const { space } = useSpaceScale();
const { bgColors } = useSemanticColors();
const portfolioStore = usePortfolioStore();


const markHt = computed(() => {
  if (portfolioStore.isDesktop) return space.value.sp6 + "px";
  return space.value.sp5 + "px";
});

</script>

<style scoped>
/* LOGO STYLING */
.wordmark_container {
  height: fit-content;
  justify-self: end;
  background-color: v-bind('bgColors.lightTranslucent');
  z-index: 10001;
}

.wordmark {
  height: v-bind('markHt');
}
</style>